import { filter, map } from 'rxjs/operators';

import { lookupAddress } from '../../../features/address-verification/reducers/addressLookup';
import { saveBusinessInfoVerify } from '../../../features/application/reducers/business-info';
import { RootEpic } from '../index';

export const saveBusinessInfoVerifyEpic: RootEpic = (action$) =>
  action$.pipe(
    filter(saveBusinessInfoVerify.match),
    map(({ payload: { address } }) =>
      lookupAddress({
        address,
        type: 'business',
      }),
    ),
  );
